export interface AccountDetailsI {
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  bio: string;
}
